import { render, staticRenderFns } from "./ScoreHelp.vue?vue&type=template&id=0b576f2a&scoped=true&lang=pug"
import script from "./ScoreHelp.vue?vue&type=script&lang=js"
export * from "./ScoreHelp.vue?vue&type=script&lang=js"
import style0 from "./ScoreHelp.vue?vue&type=style&index=0&id=0b576f2a&prod&lang=sass"
import style1 from "./ScoreHelp.vue?vue&type=style&index=1&id=0b576f2a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b576f2a",
  null
  
)

export default component.exports